import { render, staticRenderFns } from "./Society6.vue?vue&type=template&id=602581b5&scoped=true&"
import script from "./Society6.vue?vue&type=script&lang=js&"
export * from "./Society6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602581b5",
  null
  
)

export default component.exports